import { ds } from "js/core/models/dataService";
import { $ } from "js/vendor";
import { app } from "js/namespaces";
import log from "js/core/logger";
import { SideBarCanvasModifier } from "common/constants";

import { SideBar } from "js/editor/ui";
import { handleEditSharedSlide } from "js/editor/editShareSlide";

export const SpeakerNotes = SideBar.extend({
    fullScreen: false,
    className: "speaker_notes",
    type: "SpeakerNotes",
    isResizable: true,
    preventCanvasEditingWhenOpen: false,

    initialize: function({ editor }) {
        SideBar.prototype.initialize.call(this, {});

        this.editor = editor;
    },

    getTitle: function() {
        return "Speaker Notes";
    },

    getPanelHeight: function() {
        return 200;
    },

    getCanvasModifier: function() {
        return SideBarCanvasModifier.SCALE;
    },

    isCurrentSlideReadOnly: function() {
        if (!this.currentSlide) {
            return null;
        }

        return this.editor.checkIfSharedSlideIsReadOnly(this.currentSlide);
    },

    setup: function() {
        this.listenTo(ds.selection, "change:slide", (selection, slide) => {
            if (this.currentSlide?.loaded && !this.isCurrentSlideReadOnly()) {
                this.saveData();
            }

            this.currentSlide = slide;
            this.renderContents();
        });

        this.currentSlide = ds.selection.slide;
    },

    renderContents: function() {
        this.$contents.empty();
        this.$notes = this.$contents.addEl($.textarea("Type your speaker notes").addClass("speaker-notes"));
        this.$notes.attr("readonly", true);

        if (this.currentSlide) {
            this.$notes.val("Loading...");

            const slideId = this.currentSlide.id;
            this.currentSlide.load()
                .then(() => {
                    if (this.currentSlide?.id !== slideId) {
                        // Slide changed, no need to proceed
                        return;
                    }

                    this.$notes.val(this.currentSlide.get("slide_notes"));

                    if (!this.isCurrentSlideReadOnly()) {
                        this.$notes.attr("readonly", false);

                        this.$notes.on("change", () => {
                            this.saveData();
                        });
                        this.$notes.on("focus", () => {
                            app.currentCanvas.lockSlideForCollaborators(120);
                        });
                        this.$notes.on("blur", () => {
                            if (app.currentCanvas.isLockedForCollaborators()) {
                                app.currentCanvas.unlockSlideForCollaborators();
                            }
                        });
                    } else if (this.currentSlide.isLibrarySlide()) {
                        this.$notes.on("click", () => {
                            handleEditSharedSlide();
                        });
                    }
                })
                .catch(err => log.error(err));
        }
    },

    saveData: function() {
        this.currentSlide.update({ slide_notes: this.$notes.val() });
    },

    close: function() {
        $(window).off("keydown.sidebar");
        this.$notes.off("click, change, focus, blur");
        this.editor.hideSpeakerNotes(true);
    }
});
